import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutSession } from "../store/slices/sessionSlice";
import { enqueueSnackbar } from "notistack"; // ⬅ add this at the top


const IDLE_TIME = 15 * 60 * 1000;

const useAutoLogout = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const timerRef = useRef(null);

    const logout = useCallback(() => {
        localStorage.clear();
        dispatch(logoutSession())
        navigate("/", { replace: true });
        enqueueSnackbar("Session Expired. Please Login.", {
            variant: "error",
        })
    }, [dispatch, navigate]);

    const resetTimer = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            logout();
        }, IDLE_TIME);
    }, [timerRef, logout]);

    useEffect(() => {
        const events = [
            "mousemove",
            "mousedown",
            "keydown",
            "scroll",
            "touchstart",
        ];
        events.forEach((event) =>
            window.addEventListener(event, resetTimer)
        );
        resetTimer();
        return () => {
            events.forEach((event) =>
                window.removeEventListener(event, resetTimer)
            );
            clearTimeout(timerRef.current);
        };
    }, [resetTimer]);
};

export default useAutoLogout;
